<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="6">
        <v-alert type="error">You dont have access to this dashboard</v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {};
</script>

<style></style>
